import Vue from 'vue'
import Router from 'vue-router'
import { userKey, baseApiUrl } from '@/global'
import store from '../store/store.js'
import axios from "axios";

// employees routes
import homeRoute from './home.js'
import carrierRoute from './carrier.js'
import importationRoute from './importation.js'
import marketingRoute from './marketing.js'
import orderRoute from './order.js'
import productRoute from './product.js'
import quoteRoute from './quote.js'
import reportRoute from './report.js'
import partsRequirementRoute from './partsRequirement.js'
import purchaseOrderRoute from './purchaseOrder.js'
import qrCodeRoute from './qr-code.js'
import printerRoute from './printer.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...homeRoute,
    ...carrierRoute,
    ...importationRoute,
    ...marketingRoute,
    ...orderRoute,
    ...productRoute,
    ...quoteRoute,
    ...reportRoute,
    ...partsRequirementRoute,
    ...purchaseOrderRoute,
    ...qrCodeRoute,
    ...printerRoute,
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/Login.vue')
        },
        {
          path: '/error-404',
          name: 'error-404',
          component: () => import('@/views/Error404.vue')
        },
        {
          path: '/teste',
          name: 'teste',
          component: () => import('@/views/Test.vue')
        }
      ]
    },
    {
      path: '*',
      redirect: '/error-404'
    },
  ],
})

const defaultTitle = 'Regnaparts'

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.pageTitle || defaultTitle;
  window.previousUrl = from.path

  if (to.matched.some(record => record.meta.requiresAuth)) {
    const userInfo = localStorage.getItem(userKey)
    const userAuth = JSON.parse(userInfo)

    if (!userAuth) {
      router.push({ name: "login" });
      return
    }
    const res = await axios.post(`${baseApiUrl}/validateToken`, userAuth)
    if (res.data) {
      store.commit("SET_USER_INFO", userAuth)
      next()
    } else {
      localStorage.removeItem(userKey);
      router.push({ name: "login" });
    }

  } else {
    next()

  }

  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const userInfo = localStorage.getItem(userKey)
    const userAuth = JSON.parse(userInfo)
    if (userAuth.userGroup == 'admin') {
      next()

    } else {
      router.push({ name: "home" });
    }
  }



})

export default router